import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";

const AuditInfo = ({ auditData }) => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.600" mb={2}>
          Start Date
        </Text>

        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          {auditData?.startDate}
        </Text>
      </Box>

      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.600" mb={2}>
          End Date
        </Text>

        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          {auditData?.endDate}
        </Text>
      </Box>

      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.600" mb={2}>
          Audit Type
        </Text>

        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          {auditData?.type}
        </Text>
      </Box>

      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.600" mb={2}>
          Total Questions
        </Text>

        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          {auditData?.totalQuestions}
        </Text>
      </Box>

      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.600" mb={2}>
          Approved Questions
        </Text>

        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          {auditData?.approvedQuestionList?.length || 0}
        </Text>
      </Box>

      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.600" mb={2}>
          Declined Questions
        </Text>

        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          {auditData?.rejectedQuestionList?.length || 0}
        </Text>
      </Box>

      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.600" mb={2}>
          Auditors
        </Text>

        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          {auditData?.auditors?.map((auditor) => auditor).join(", ")}
        </Text>
      </Box>
    </SimpleGrid>
  );
};

export default AuditInfo;
